<template lang="pug">
q-dialog#auto-activity-form(
  :value="isAutoActivitiesFormShownLocal",
  seamless,
  position="right",
  @hide="hideAutoActivitiesDialog"
)
  q-card.workflow-form__card
    .spinner-container.form-spinner-container(v-if="loading")
      q-spinner(color="primary", size="3em")
    template(v-else)
      .row
        .col-10
          span.text-h6.text-bold.workflow-form__card__title {{ workflowConstructorLocales.auto_activities_managment }}
        .col-2.workflow-form__card__close-icon
          q-btn(flat, round, icon="close", @click="hideAutoActivitiesDialog")
      .workflow-form__card__scroll
        .scroll-placeholder(v-if="!activityTriggers?.length") 
          i {{ workflowConstructorLocales.empty_list }}
        .row(v-else)
          .col-12.list-element(v-for="activityTrigger in activityTriggers", :key="activityTrigger.id")
            .workflow-form__card__activity-wrapper(@click="openCreate(activityTrigger)")
              .activity-name {{ activityTrigger.title }}
              .icon-delete
                inline-svg(
                  :src="require('../../../../assets/icons/trash.svg')",
                  @click.stop="openDelete(activityTrigger)"
                )

        CreateAutoActivityForm(
          v-if="isCreateAutoActivityFormShown",
          :activityTrigger="currentAutoActivity",
          :workflowId="workflowId",
          :isCreateAutoActivityFormShown="isCreateAutoActivityFormShown",
          :status="status",
          @createAutoActivity="createAutoActivity",
          @updateAutoActivity="updateAutoActivity",
          @hideDialog="isCreateAutoActivityFormShown = false"
        )

        DeleteAutoActivityForm(
          v-if="isDeleteAutoActivityFormShown",
          :id="currentAutoActivity ? parseInt(currentAutoActivity?.id) : null",
          :isDeleteAutoActivityFormShown="isDeleteAutoActivityFormShown",
          @deleteAutoActivity="deleteAutoActivity",
          @hideDialog="isDeleteAutoActivityFormShown = false"
        )
      .row
        .col-6.workflow-form__card__button
          q-btn.workflow-form__card__button--close(flat, no-caps, @click="hideAutoActivitiesDialog") {{ workflowConstructorLocales.cancel }}
        .col-6.workflow-form__card__button
          q-btn.workflow-form__card__button--accept.workflow-form__card__button--create(
            flat,
            no-caps,
            icon="add",
            @click="openCreate"
          ) {{ workflowConstructorLocales.create_activity }}
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

import backend from "@/api";
import { handleError } from "@/services/handleErrors";
import { workflowConstructorLocales } from "@/services/useLocales";

import CreateAutoActivityForm from "./CreateAutoActivityForm";
import DeleteAutoActivityForm from "./DeleteAutoActivityForm";

const props = defineProps({
  /* титульное название формы (с айди статуса) */
  title: { type: String, default: "" },
  /* объект, содержащий в себе статус в формате признак: значение 
  {
    "id":1,
    "title":"новая",
    "workflow_id":1,
    "started":true,
    "terminated":false,
    "pause_available":false,
    "accepted":false,
    "percentage_completion":0,
    "template":{"color":"#5b7aff","position":["357","70"]},
    "created_at":"2023-04-25 09:16:43 UTC",
    "updated_at":"2025-05-20 13:46:03 UTC",
    "deleted_at":null,
    "roles":["2","3","4","9","10","11","12","13"],
    "external_id":null,
    "max_duration":0,
    "formated_duration":"0с.",
    "activities":[],
    "transitions":
      [
        {
          "id":1,
          "title":"Принять",
          "old_status":{"id":1,"title":"новая"},
          "new_status":{"id":2,"title":"принята"},
          "form":{
            "id":1,
            "title":"Accept Form",
            "validations":[
              {
                "id":7075,
                "attribute":"executor_id",
                "type":null,
                "options":{},
                "attribute_title":"Исполнитель"
              },
            ]
          },
          "roles":["2","4","10","3","5","9","11","12","13","16"],
          "template":{"color":"#c181ff"},
          "created_at":"2023-04-25 09:16:43 UTC",
          "updated_at":"2025-02-27 11:27:04 UTC"},
        }
      ],
      "days":0,
      "hours":0,
      "minutes":0
    }
  */
  status: { type: Object, default: () => {} },
  /* идентификатор текущего воркфлоу */
  workflowId: { type: Number, default: null },
  /* булеан показа формы */
  isAutoActivitiesFormShown: { type: Boolean, default: false },
});

const emit = defineEmits(["hideDialog"]);

const loading = ref(true);
const activityTriggers = ref(props.status.activity_triggers);
const isCreateAutoActivityFormShown = ref(false);
const isDeleteAutoActivityFormShown = ref(false);

const currentAutoActivity = ref(null);

const isAutoActivitiesFormShownLocal = computed(() => props.isAutoActivitiesFormShown && !!props.status);

const hideAutoActivitiesDialog = () => {
  currentAutoActivity.value = null;
  emit("hideDialog");
};

const setCurrentAutoActivityOrPurgeIt = activityTrigger => {
  if (activityTrigger?.id) currentAutoActivity.value = activityTrigger;
  else currentAutoActivity.value = null;
};

const openCreate = activityTrigger => {
  setCurrentAutoActivityOrPurgeIt(activityTrigger);

  isCreateAutoActivityFormShown.value = true;
};

const openDelete = activityTrigger => {
  setCurrentAutoActivityOrPurgeIt(activityTrigger);

  isDeleteAutoActivityFormShown.value = true;
};

const hideCreate = () => {
  currentAutoActivity.value = null;
  isCreateAutoActivityFormShown.value = false;
};

const hideDelete = () => {
  currentAutoActivity.value = null;
  isDeleteAutoActivityFormShown.value = false;
};

const createAutoActivity = activityTrigger => {
  activityTriggers.value.push(activityTrigger);
  emit("createAutoActivity", { statusId: props.status.id, activityTrigger });
};

const updateAutoActivity = activityTrigger => {
  const currentIndex = activityTriggers.value.findIndex(el => el.id === activityTrigger.id);
  if (currentIndex !== -1) {
    activityTriggers.value[currentIndex] = activityTrigger;
    emit("updateAutoActivity", { statusId: props.status.id, activityTrigger });
  }
};

const deleteAutoActivity = id => {
  activityTriggers.value = activityTriggers.value.filter(el => parseInt(el.id) !== parseInt(id));
  emit("deleteAutoActivity", { id: id, statusId: props.status.id });
};

onMounted(async () => {
  loading.value = false;
});
</script>

<style lang="scss"></style>
